import InvestmentsFilterSelect from './investments-filter-select';

export default InvestmentsFilterSelect;
